<div class="card mb-2">
  <div class="card-body">
    <div class="card-title row">
      <div class="col-6">
        <div class="row">
          <div class="col-md-6">
            <a [routerLink]="'/orders/' + data.id">
              <i class="fas fa-eye pr-1"></i>
              <h5 class="link-font-size">{{ data.id }}</h5>
            </a>
          </div>
          <div class="col-md-6">
            <a target="_NEW" [href]="getTrackOrderLink(data.id)">
              <i class="far fa-truck"></i>
              <h5 class="link-font-size">&nbsp;{{ 'TYLO_TRACK_ORDER' | translate }}</h5>
            </a>
          </div>
        </div>
      </div>
      <div class="col-auto ml-auto">
        <lib-action-btn [item]="data" [config]="configService"></lib-action-btn>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12 col-md-4">
        <div class="pb-1">
          <lib-gung-date-output [gungTranslate]="'ORDER_DATE'" [value]="data.extra.oh.orddatum"></lib-gung-date-output>
        </div>
        <div class="pb-1">
          <lib-gung-date-output [gungTranslate]="'EXPECTED_DELIVERY_DATE'" [value]="data.extra.oh.ordberlevdat">
          </lib-gung-date-output>
        </div>
      </div>
      <div class="col-xs-12 col-md-4">
        <div class="pb-1">
          <lib-gung-text-input
            [ngModel]="'OH_ORDSTAT_' + data.extra.oh.ordstat | translate"
            [renderStatic]="true"
            [gungTranslate]="'ORDER_STATUS'"
          ></lib-gung-text-input>
        </div>
        <div class="pb-1">
          <lib-gung-text-input
            [gungTranslate]="'TOTAL'"
            [renderStatic]="true"
            [ngModel]="data.extra.oh.ohvbordsum | gungCurrency: data.extra.oh.valkod:'symbol-narrow':'1.2-2'"
          >
          </lib-gung-text-input>
        </div>
      </div>
      <div class="col col-xs-6 col-md-4">
        <div class="pb-1">
          <!-- <lib-gung-text-input [gungTranslate]="'NAME'" [renderStatic]="true"
            [ngModel]="data.extra.oh.ordlevadr1 || (data.extra.deliveryCustomer ? data.extra.deliveryCustomer.name : data.extra.customerName)">
          </lib-gung-text-input> -->
          <lib-gung-text-input
            [gungTranslate]="'OH_KUNDBESTNR'"
            [renderStatic]="true"
            [ngModel]="data.extra.oh.kundbestnr"
          >
          </lib-gung-text-input>

          <div class="pb-1">
            <lib-gung-meta-output
              [value]="data.extra.oh.ordlevadrlandskod"
              [gungTranslate]="'COUNTRY'"
              metadataTable="xr"
              metaOptionName="land"
            ></lib-gung-meta-output>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
